export default "__VITE_ASSET__CUhU16dE__";